import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8 15h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 19h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 21h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 15h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 19h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CloudSnow";
const CloudSnow = memo(themed(Icon));
export {
  CloudSnow
};
//# sourceMappingURL=cloud-snow.js.map
